export default {
  allRoles: [],
  role: {},
}
